import { colors } from "@dotnet/telematics-design-system";

const useRangePickerStyles = () => {
    const { blue800, blue700, gray100, gray900, white } = colors;

    const bgColorTransition = {
        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    };

    const setGeneralStyles = (
        width: string,
        borderRadius: string,
        margin: string,
        background: string,
        color: string,
        hasBorder?: boolean,
        hasPseudo?: boolean
    ) => ({
        width,
        background,
        margin,
        color,
        borderRadius,
        ...(!hasBorder ? { border: "none" } : {}),

        ...(hasPseudo
            ? {
                  "&:focus": {
                      background: blue700
                  },

                  "&:hover": {
                      background: blue800,
                      ...bgColorTransition
                  }
              }
            : {})
    });

    const setSpecificStyles = (
        isFirstSelected: boolean,
        isLastSelected: boolean,
        isMiddleSelected: boolean,
        isInHoverRange: boolean,
        isToday: boolean
    ) => {
        if (isFirstSelected && isLastSelected) {
            return {
                ...setGeneralStyles(
                    "32px",
                    "50%",
                    "0 5px",
                    blue700,
                    white,
                    false,
                    true
                )
            };
        }

        if (isFirstSelected) {
            return {
                ...setGeneralStyles(
                    "37px",
                    "50% 0 0 50%",
                    "0 0 0 5px",
                    blue700,
                    white,
                    false,
                    true
                )
            };
        }

        if (isMiddleSelected) {
            return {
                ...setGeneralStyles(
                    "42px",
                    "0",
                    "0",
                    blue700,
                    white,
                    false,
                    true
                ),
                ...bgColorTransition
            };
        }

        if (isLastSelected) {
            return {
                ...setGeneralStyles(
                    "37px",
                    "0 50% 50% 0",
                    "0 5px 0 0",
                    blue700,
                    white,
                    false,
                    true
                )
            };
        }

        if (isInHoverRange) {
            return {
                ...setGeneralStyles(
                    "42px",
                    "0",
                    "0",
                    gray100,
                    gray900,
                    false,
                    false
                ),
                ...bgColorTransition
            };
        }

        return isToday
            ? {
                  ...setGeneralStyles(
                      "32px",
                      "50%",
                      "0 5px",
                      white,
                      gray900,
                      true,
                      false
                  ),

                  "&:hover": {
                      ...setGeneralStyles(
                          "42px",
                          "0",
                          "0",
                          gray100,
                          gray900,
                          false,
                          false
                      )
                  }
              }
            : {
                  ...setGeneralStyles(
                      "42px",
                      "0",
                      "0",
                      white,
                      gray900,
                      true,
                      false
                  )
              };
    };

    return {
        bgColorTransition,
        setSpecificStyles
    };
};

export { useRangePickerStyles };
